import React from "react";
import { twMerge } from "tailwind-merge";

export type HyperlinkProps = React.ComponentProps<"a"> & {};

export const Hyperlink: React.FC<HyperlinkProps> = React.forwardRef<
  HTMLAnchorElement,
  HyperlinkProps
>(({ className, ...props }, ref) => {
  return (
    <a
      ref={ref}
      className={twMerge("underline", className)}
      rel="noopener noreferrer"
      {...props}
    />
  );
});
